import React, { useState, useEffect } from 'react';

import { prepareInput, splitInputsByRenderBlock } from '../../Input';
import { selfFormInputs } from './selfFormInputs';
import { Button } from '~c/ui/Button';
import { Promo } from '../../Promo';
import { CheckSubscribe } from '../../CheckSubscribe';
import { passportPatterns, registerStudents, eventTypes } from '../../utils';
import { FormMessage } from '~c/FormMessage';
import openErrorMsgForm from '~c/popups/ErrorSender';

import messages from '~h/messages';
import { checkNotEmpty, checkPassport } from '~h/validators';
import { passportFormatting } from '../../../../helpers/textFormatting';
import metrikaGoal from '../../../../helpers/metrikaGoal';
import {registerAnalyticEvent} from '../../analytics';

export const SelfReg = (props) => {
	const [inputs, setInputs] = useState(selfFormInputs);
	const [formData, setFormData] = useState({});
	const [dadataValueExists, setDadataValueExists] = useState(false);
	const [isPending, setIsPending] = useState(false);
	const [subscribe, setSubscribe] = useState(true);
	const [errorMessages, setErrorMessages] = useState([]);
	const [promo, setPromo] = useState('');

	const userCitizenshipCode = props.user?.citizenshipCode || 'RU';

	useEffect(() => {
		const processPassport = (passport, citizenshipCode) => {
			if (passport) {
				if (citizenshipCode === 'RU') {
					return passportFormatting(passport);
				}
				return passport;
			}
			return '';
		};

    setFormData({
			company: props.user?.company || '',
			companyPosition: props.user?.companyPosition || '',
			passport: processPassport(props.user?.passport, props.user?.citizenshipCode),
			passportCreated: props?.user?.passportCreated || '',
			birthday: props.user?.birthday || '',
			citizenship: props.user?.citizenship || 'Российская Федерация',
			citizenshipCode: userCitizenshipCode,
			passportPlaceCreated: props.user?.passportPlaceCreated || '',
			addressOfRegistration: props.user?.registrationAddress || '',
    });

		const pattern = passportPatterns.find((mask) => mask.citizenshipCode === userCitizenshipCode);
		const newInputs = inputs.map((input) => {
			if (input.name === 'passport') {
				return {
					...input,
					mask: pattern?.mask ? pattern.mask : '',
					validator: pattern ? checkPassport : checkNotEmpty
				};
			}
			return input;
		});

		setInputs(newInputs);
  }, [props.user]);

	const changeInput = (name, val, dadataValue = null) => {
		const newFormData = Object.assign({}, formData);

		if (name === 'citizenship') {
			const { citizenshipCode } = formData;

			if (val.citizenship || val.type === 'onChange' && val.citizenship === '') {
				const pattern = passportPatterns.find((mask) => mask.citizenshipCode === val.citizenshipCode);

				setInputs(inputs.slice().map((inp) => {
					const newInp = Object.assign({}, inp);
					if (newInp.name === 'passport') {
						newInp.mask = pattern?.mask ? pattern.mask : '';
						newInp.validator = pattern ? checkPassport : checkNotEmpty;
						newInp.error = false;
					}
					return newInp;
				}));

				newFormData.citizenship = val.citizenship;
				newFormData.citizenshipCode = val.citizenshipCode;

				if (pattern) newFormData.passport = passportFormatting(formData.passport);
			} else if (!citizenshipCode) {
					newFormData.citizenship = '';
					newFormData.citizenshipCode = '';
				}
		} else {
			newFormData[name] = val;
		}

		if (name === 'company') setDadataValueExists(!!dadataValue);

    setFormData(newFormData);
	};

  const isValidInput = (inputObject, inputValue) => {
    if (inputObject.validator) return inputObject.validator(inputValue);
    if (inputObject.required && inputValue) return true;
    return !inputObject.required;

  };

	const validateInput = name => {
    const currentInputIndex = inputs.findIndex(input => input.name === name);
    const currentInput = inputs[currentInputIndex];

    const isValid = isValidInput(currentInput, formData[currentInput.name]);

    if (!isValid !== currentInput.error) {
      const newInputs = inputs.slice(0);
      newInputs[currentInputIndex] = { ...currentInput, error: !isValid };
      setInputs(newInputs);
    }
  };

	const validateForm = () => {
    const newInputs = inputs.slice(0);

    let isValidationPassed = true;
    newInputs.forEach((input, index) => {
      const isValid = isValidInput(input, formData[input.name]);

      isValidationPassed = isValidationPassed && isValid;
      if (!isValid !== input.error) {
        newInputs[index] = { ...input, error: !isValid };
      }
    });
    setInputs(newInputs);

		const errors = [];

		if(!isValidationPassed) errors.push(messages.formError);

    setErrorMessages(errors);

    return isValidationPassed;
  };

  const onSubmit = async () => {
    if (isPending) return;

		const { eventCode, pageCode, currentLead, user } = props;
		const options = {
			subscribe,
			promo,
			eventCodes: [eventCode],
			pageCode,
			isSelfReg: true,
			isCompanyReg: false,
			currentLead
		};
    if (!validateForm()) {
      // eslint-disable-next-line no-console
      console.error('forms invalid');
      return;
    }
		setErrorMessages([]);

		setIsPending(true);
		if (props.eventTypes === "CONSULT") metrikaGoal('createConsultPersonalReg');
		if (props.eventTypes === "EDU") metrikaGoal('createEduPersReg');

		if (subscribe) props.sendUsersData({data: user, isNewsSubscribe: subscribe});
		try{
			const response = await registerStudents([formData], options);
			setIsPending(false);

			switch(response[0].status) {
			case 'success':
				if (props.eventTypes === eventTypes.EDU) {
					props.cbDataForEduServices({
						visualType: 'user',
						body: [{
							id: window.user.CONTACT_ID,
							name: window.user.FIRST_NAME,
							lastName: window.user.LAST_NAME,
						}]
					});
				}
				metrikaGoal('successReg');
				registerAnalyticEvent();
				props.nextStep();
				break;
			case 'error':
				setErrorMessages([response[0].errors[0].message]);
				break;
			default:
				setErrorMessages([messages.unknownError]);
				throw new Error(messages.unknownError);
			}
		}catch(e){
			const errorText = `${e.name} : ${e.message}`;
        const title = document.getElementsByTagName('h1')[0]?.innerHTML || '';
        const currentLocation = window.location.pathname;
        const error = {
          errors: errorText,
          page: `Регистрация. Страница: ${title}. URL: ${currentLocation}`
        };
			openErrorMsgForm(error);
		}
  };

	const splittedInputs = splitInputsByRenderBlock(inputs);

	return (
		<div className={`registration__block ${props.isCompanyReg ? 'hidden' : ''}`}>
			<div className="registration__form">
				{splittedInputs.map((block) => (
					<div className="inp-wrap" key={block[0].name}>
						{block?.map(input =>
							prepareInput({
								...input,
								value: formData[input.name],
								onChangeCallback: changeInput,
								onBlurCallback: validateInput,
							}),
						)}
					</div>
				))}
			</div>
			<div className="separate" />
			<Promo onChange={code => setPromo(code)} eventCode={props.eventCode} />
      <div className="separate" />
      { errorMessages.length >= 1 && (
        <React.Fragment>
          <FormMessage extraClass="error">
            { errorMessages.map((error) => <p className="form-message__p" key={error}>{error}</p>)}
          </FormMessage>
        </React.Fragment>
      )}
			{ (props.checkSubscribe || props.user?.subscribe) ||
     		<CheckSubscribe checked={subscribe} onChange={setSubscribe} />
			}
			<div className="registration__btns">
				<Button isPending={isPending} onClick={onSubmit}>Зарегистрироваться</Button>
			</div>
		</div>
	);
};